import { render } from "./RequestSvg.vue?vue&type=template&id=2ef6ec1a"
const script = {}

import "./RequestSvg.vue?vue&type=style&index=0&id=2ef6ec1a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__